/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Backend,
    BackendFromJSON,
    BackendFromJSONTyped,
    BackendToJSON,
    FSProperties,
    FSPropertiesFromJSON,
    FSPropertiesFromJSONTyped,
    FSPropertiesToJSON,
    VolumeStatus,
    VolumeStatusFromJSON,
    VolumeStatusFromJSONTyped,
    VolumeStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface Volume
 */
export interface Volume {
    /**
     * 
     * @type {number}
     * @memberof Volume
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Volume
     */
    path?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Volume
     */
    nodes: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Volume
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Volume
     */
    visualTag?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Volume
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Volume
     */
    useForHomes?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Volume
     */
    useForWorkspaces?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Volume
     */
    type?: VolumeTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Volume
     */
    snmEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Volume
     */
    snfsName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Volume
     */
    simulatedQuotas?: boolean;
    /**
     * 
     * @type {FSProperties}
     * @memberof Volume
     */
    fsProperties?: FSProperties;
    /**
     * 
     * @type {Backend}
     * @memberof Volume
     */
    backend: Backend;
    /**
     * 
     * @type {VolumeStatus}
     * @memberof Volume
     */
    status?: VolumeStatus;
    /**
     * 
     * @type {number}
     * @memberof Volume
     */
    cloudAccount?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum VolumeTypeEnum {
    Generic = 'generic',
    GenericMount = 'generic-mount',
    Snfs = 'snfs',
    Btrfs = 'btrfs',
    Lizardfs = 'lizardfs',
    Bcachefs = 'bcachefs',
    Onefs = 'onefs',
    Beegfs = 'beegfs',
    Cloud = 'cloud'
}

export function VolumeFromJSON(json: any): Volume {
    return VolumeFromJSONTyped(json, false);
}

export function VolumeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Volume {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'nodes': json['nodes'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'visualTag': !exists(json, 'visual_tag') ? undefined : json['visual_tag'],
        'isDefault': !exists(json, 'is_default') ? undefined : json['is_default'],
        'useForHomes': !exists(json, 'use_for_homes') ? undefined : json['use_for_homes'],
        'useForWorkspaces': !exists(json, 'use_for_workspaces') ? undefined : json['use_for_workspaces'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'snmEnabled': !exists(json, 'snm_enabled') ? undefined : json['snm_enabled'],
        'snfsName': !exists(json, 'snfs_name') ? undefined : json['snfs_name'],
        'simulatedQuotas': !exists(json, 'simulated_quotas') ? undefined : json['simulated_quotas'],
        'fsProperties': !exists(json, 'fs_properties') ? undefined : FSPropertiesFromJSON(json['fs_properties']),
        'backend': BackendFromJSON(json['backend']),
        'status': !exists(json, 'status') ? undefined : VolumeStatusFromJSON(json['status']),
        'cloudAccount': !exists(json, 'cloud_account') ? undefined : json['cloud_account'],
    };
}

export function VolumeToJSON(value?: Volume | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path': value.path,
        'nodes': value.nodes,
        'display_name': value.displayName,
        'visual_tag': value.visualTag,
        'is_default': value.isDefault,
        'use_for_homes': value.useForHomes,
        'use_for_workspaces': value.useForWorkspaces,
        'type': value.type,
        'snm_enabled': value.snmEnabled,
        'snfs_name': value.snfsName,
        'simulated_quotas': value.simulatedQuotas,
        'fs_properties': FSPropertiesToJSON(value.fsProperties),
        'backend': BackendToJSON(value.backend),
        'status': VolumeStatusToJSON(value.status),
        'cloud_account': value.cloudAccount,
    };
}


